
// src/connects/group-nav.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import actions from '../actions'
import { translate } from 'react-i18next'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { emitAlertMessage } from '../actions/alert-message'

export const mapStateToProps = (state, ownProps)=> {
  const unreadCount = state.notifications.unreadCount

  return {
    isPhone: state.media.isPhone,
    user: state.user.current,
    notificationUnreadCount: unreadCount && unreadCount[ownProps.group.group_id],
    chatUnreadCount: state.chatRooms.unreadCount,
    announce: !state.announce.close,
    firstLogin: state.user.firstLogin,
    productTour: state.productTour.state,
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    blinkChatButton: stateProps.firstLogin && (!stateProps.productTour || stateProps.productTour.chatRoom != 'hide'),
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
	const params = {
		group_id: ownProps.group.group_id,
		group: ownProps.group
	}
  return {
    onLeftIconClick: ()=> dispatch(actions.openSidebar()),
    showNotifications: ()=> dispatch(actions.openRightSidePage('notifications', params)),
    showChatRooms: ()=> dispatch(actions.openRightSidePage('chat_rooms', {})),
    openGroupSettingsPage: ()=> dispatch(actions.openGroupSettingsPage()),
    openGroupDetailsPage: ()=> dispatch(actions.openRightSidePage('group_details', params)),
    openMembersPage: ()=> dispatch(actions.openRightSidePage('group_members', params)),
    openDashboardPage: ()=> dispatch(actions.openRightSidePage('dashboard', params)),
    openReportStatusPage: ()=> dispatch(actions.openRightSidePage('report_status', params)),
    openKPIPage: ()=> {
      dispatch(actions.openRightSidePage('kpi_page', params))
      dispatch(actions.clearClosedKpis())
    },
    toggleFavorite: ()=> {
      dispatch(actions.updateFavoriteGroup(ownProps.group.group_id, !ownProps.group.favorite))
      if (!ownProps.group.favorite)
        dispatch(emitAlertMessage({ message: 'label:お気に入りグループに追加しました', name: ownProps.group.name }, 'success'))
      else
        dispatch(emitAlertMessage({ message: 'label:お気に入りグループから削除しました', name: ownProps.group.name }, 'success'))
    },
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({ state: { searchDrawer: false }}),
  translate(),
  lifecycle,
)



// WEBPACK FOOTER //
// ./src/connects/group-nav.js